module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter Two")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("W")])]), _vm._v("hile Trev finished taking their baggage to the chamber they would share, Blaidd waited for Lord Throckton in the great hall. He stood with his back to the massive hearth, and the heat felt so good, he barely managed not to squirm like a pig in mud.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("His mood continued to improve as he surveyed the chamber, which, like the rest of the fortress, was larger and more indicative of personal wealth than he had expected. After entering the cobbled courtyard, he’d taken note of the huge building that had to be the hall, and the chapel beside it, judging by the windows. The rooms on the second level of the half-timbered stables were surely barracks for the garrison and living quarters for grooms and stable boys. Blaidd guessed the two-story building on this side of the yard, adjoining the hall, contained the apartments where the family and the other servants slept, as well as the lord’s solar. The other buildings he could readily identify were the kitchen, attached to the hall and ")]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("with a large chimney louvered so that rain couldn’t put out the fire below, and the blacksmith’s shop. The keep, a huge circular building to the left of the entrance, probably doubled as the armory, and would serve as a last redoubt should the walls be breached.")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The keep was decades old, and the inner walls, too. Blaidd estimated that the hall, the chapel, the outer wall and the formidable gatehouse were new, built within the last five years. The second floors—the apartments and barracks—were likewise of recent construction.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("As for the interior of the hall, the only place Blaidd had seen to rival it belonged to the king. Heavy and finely wrought tapestries covered the walls, depicting battles and hunts, their bright green, scarlet and gold threads catching the light. The benches and tables were relatively new, free of scars, scratches and gouges, and polished to a high sheen. Clean rushes covered the floor, and the light scents of rosemary and fleabane reached his nostrils.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Huge oak beams supported the ceiling, and banners of knights who owed allegiance to Lord Throckton moved in the shifting air like lazy maidens dancing. It was quite a collection—far more than Blaidd would have expected for a lord of Throckton’s apparent standing—and most of them were unfamiliar. Should the king’s suspicions about Throckton’s possible disloyalty prove well founded, he would have to remember them.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("One of the hounds slumbering near the fire twitched, drawing his attention. They had stood ")]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("growling and quivering at him when he had first entered, until one of the male servants had commanded them to sit and be quiet.")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("That wench at the gate had practically snapped and growled at him, too. What would "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("she")]), _vm._v(" look like asleep, her bright blue eyes closed and her breasts rising and falling in gentle rhythm? He recalled hints of the form beneath that damp cloak she held so tightly about her, and realized she was quite shapely.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("His body warmed more, and not from the fire, as he imagined the spirited Becca in his bed. She wouldn’t lie there unmoving, he was sure. If she decided to give herself to a man, she would—with zest. He would be free to tease and suggest and play, and she would probably respond in kind.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He began to harden, and forcibly reminded himself he had important business here that had nothing to do with women, even if he was supposed to be interested in Lady Laelia. And he should no more dally with a maidservant than Trev should go to that brothel, no matter how interesting or challenging the maidservant might be.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Welcome to Throckton Castle, Sir Blaidd!” a deep voice called out.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Blaidd swiveled toward a curving stairway at the far end of the hall. A robust man with thick gray hair and broad shoulders strode toward him. He was well-dressed, wearing a long tunic of indigo blue belted with gilded leather. By his manner and confidence Blaidd assumed he was the lord of the castle.")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("When Lord Throckton reached the dais, he came to a halt and smiled pleasantly, revealing fine teeth.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Blaidd, however, had spent years among hypocritical courtiers so he quickly realized that the friendly smile did not reach the man’s hazel eyes. They were as wary as the girl’s at the gate.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The hairs on the back of Blaidd’s neck tickled, as if he was trying to pick his way across swampy land, yet he betrayed nothing of his foreboding. After all, what man wouldn’t be suspicious of a knight who arrived without warning? And it could be that his own disinclination for subterfuge was making him more suspicious than he should be. “Greetings, Lord Throckton,” he said as he bowed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Nasty weather for traveling,” the nobleman noted.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Which is why I’m thankful for your hospitality.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Think nothing of it, man! It’s my pleasure.” Lord Throckton’s smile grew, but his eyes did not lose their shrewd wariness. “Still, I doubt it’s merely chance that brings you so far from the main road.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“No, it isn’t,” Blaidd replied with his friendliest smile. “However, my reason for coming here is one that I would prefer to speak of in private, if we may.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Of course! We can discuss what brings you here in my solar.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Lord Throckton led Blaidd toward the staircase he had just descended, glancing over his shoulder to ensure that he was following.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("They reached a landing, and Lord Throckton opened the door leading off it. He gestured for Blaidd ")]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("to enter the chamber first, and when he did, he found himself in a very comfortable room that provided more evidence that Lord Throckton was rich and liked his creature comforts. More colorful tapestries covered the walls, and the chairs, of pale new oak, sported silken cushions in bright, jewel-like colors. A trestle table was covered with parchments, vessels of ink, several quills and a silver candleholder. An open chest painted blue and green revealed parchment scrolls, likely the records of tithes and other estate business. A bronze brazier glowed with coals and a carpet covered much of the stone floor. Linen shutters over the tall, narrow windows shut out the chill spring breeze.")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("It was like being in a warm, comfortable, Oriental cocoon, and a far cry from many a nobleman’s plain, chilly solar.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("With a sigh of pleasure, Lord Throckton sank onto the scarlet silk cushion on the ornately carved chair decorated with vines, leaves and grapes behind the table. He gestured for Blaidd to sit in a slightly less intricately carved chair opposite.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Are you related to Sir Hu Morgan, by any chance?” Lord Throckton asked when Blaidd had done so.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Blaidd didn’t hide his surprise that the man knew who his father was. “I’m his son. Have you met him?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("Lord Throckton’s eyes crinkled as he smiled again. “No. As I’m sure you’re aware, I don’t go to court. Westminster and London are too noisy and crowded ")]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("for my taste. But I’ve heard of him nonetheless. He has many important friends.”")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“My father rarely goes to court, either,” Blaidd replied, electing to say nothing of his father’s friends, some of whom were very powerful indeed. “He shares your dislike of cities, and he prefers to stay at home.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“With your mother, who was reputed to be the most beautiful lady of her time,” Lord Throckton added with a chuckle. “A wise and happy man.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Blaidd inclined his head and didn’t disagree.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I recall many people were shocked that Lady Liliana married a man who had been born a shepherd.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He didn’t speak with obvious disrespect or malice, but Blaidd’s jaw clenched regardless. He didn’t reply until he’d mastered the flash of anger such statements about his parents’ marriage always elicited. “My father was a knight when she wed him.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“And a very handsome fellow himself, like his son. So I suppose that you’ve come to woo my beautiful daughter?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Word of the lady’s qualities have reached the court, and I am unwed. I hope you won’t hold my father’s birth against me, but will allow me the privilege of meeting her, at least.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Indeed, I shall. I have a great respect for men who have risen above their station,” Lord Throckton replied with every vestige of sincerity. “So does my daughter.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Then may I also have your permission to woo her if she’s willing, my lord?”")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Lord Throckton toyed with the thick gold ring on his left hand and ran a measuring glance over Blaidd’s clothes. The atmosphere in the room shifted subtly. “You haven’t asked about her dowry, Sir Blaidd.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“From all that I’ve heard about your daughter, Lady Laelia herself will be the true prize.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Lord Throckton looked pleased. “Naturally, I agree, but I don’t think it’ll trouble you to know her dowry won’t be small. Nor will it be the largest you’ve ever heard of. But I’ve had many offers from many men for Laelia, from the time she was twelve years old, and not a one of them complained about her dowry.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Blaidd bestowed a smile on his host. “Despite my attire, I’m not a poor man who seeks only wealth when it comes to a bride, my lord. I’m dressed thus because it’s prudent when on the road, to avoid tempting outlaws.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I should warn you, Sir Blaidd, it’s not Laelia’s heart you have to win over. It’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("my")]), _vm._v(" head. Be you knight or commoner, comely or not, and friend of the king or no, it’s me you have to impress, not her. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I")]), _vm._v(" have refused every man who asked for her. Are you still willing to try to woo and win her?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Blaidd nodded. “If you are willing to allow me the opportunity, my lord.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("“I am, and you are welcome to stay for as long as you like.” Lord Throckton put his hands on the arms of his chair and hoisted himself to his feet. “Now that we’ve reached an agreement, Sir Blaidd, the eve")]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("ning meal should be ready, and I am near to starving. Shall we?”")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Blaidd rose and followed the man back down to the hall, which was now crowded with tables, benches, servants and soldiers. Trev was waiting near one of the tables, and after a nod to Blaidd, the lad continued his survey of the impressive hall and bevy of servants.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The hounds, now roused and hungry, prowled among the tables, noses aloft. Several of the men didn’t look much different, and Blaidd couldn’t blame them, for the aromas wafting out of the corridor that led to the kitchen smelled heavenly. His stomach growled in response, for his last meal had been half a loaf of bread that morning, accompanied by a drink from a stream.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Here is my lovely Laelia already waiting,” Lord Throckton said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Blaidd’s gaze followed the man’s gesture toward the dais, and then his breath caught in his throat. He had met many a beautiful woman, especially since more than one went out of their way to be introduced to him. But he had never, ever seen a woman who was as truly, absolutely beautiful as this one was. Dressed in pale blue velvet raiment, Lady Laelia was like an angelic vision, with perfect features, a graceful swanlike neck and shining blond hair cascading in curling waves over her slender shoulders. The picture was made perfect by her attitude of modesty, her head lowered as she stared at the rush-covered floor.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Is she not a beauty?”")])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Indeed, my lord, words fail me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Lord Throckton chuckled with pride and continued through the assembly like a horse through high grass.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Blaidd looked at the dais again—and got a second, even stronger jolt of shock that made him check his step.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("What the devil was that wench doing seated at the high table? Wasn’t she a servant? This meant she couldn’t be, and if she wasn’t, what the devil was she? What had she been doing at the gate?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Perhaps she was a friend of Lady Laelia’s, and her interrogation of him had been her idea of a joke.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("But then why would she be seated while Lord Throckton still stood?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The woman’s blue-eyed gaze locked on to him, and even from this distance, he could tell that she was amused by his surprise. As she continued to regard him with that mocking merriment, energy and determination fairly hummed in Blaidd’s veins. Whoever she was, and whatever she thought she was doing, she was going to rue the day she’d made Sir Blaidd Morgan feel like a fool.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Lord Throckton reached the dais ahead of him and took the blond beauty’s hand, leading her a little forward. “This is my daughter, Lady Laelia. Laelia, this is Sir Blaidd Morgan, from the king’s court.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The lady didn’t raise her head or her eyes—a blessed change from being looked at as if he were a trained bear sent solely for someone’s amusement, Blaidd decided.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("He bowed low and took her right hand, as limp and ")]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("cool as a fish in a basket, and brought it to his lips to kiss. “My lady, reports of your beauty don’t begin to do you justice,” he said as he straightened.")])]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("It was an easy, unoriginal compliment. Usually he enjoyed exerting himself for a lady’s good regard, especially a beautiful one, but it must be the presence of that insolent wench that made his mind incapable of coming up with better flattery.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“You’re most welcome to our hall,” Lady Laelia replied, raising grass-green eyes to look at him, her tone high-pitched and breathless, like a little girl’s. Or a woman trying to sound younger than she was.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He couldn’t remember anybody ever saying how old Lady Laelia was.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The brown-haired young woman loudly—and rudely—cleared her throat. Was she some sort of mad relative? That would explain her place, and her bizarre behavior.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Lord Throckton’s thick gray brows lowered and he frowned as he looked at her. “Sir Blaidd, this is Rebecca. My other daughter.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Daughter?")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("No one had ever mentioned that Lord Throckton had another daughter, perhaps because she wasn’t as beautiful as her sister, and was decidedly insolent.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Her lack of beauty might explain her rudeness, though. Envy may have twisted her into a bitter shrew.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("“What, no compliment for me, Sir Blaidd?” Lady Rebecca asked as she tilted her head and gave him a merry smile. “Granted, I’m no match for Laelia, but ")]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("aren’t all you courtiers trained in flattery? Surely you won’t disappoint me.”")])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Rising to the challenge, Blaidd laid his hand over his heart and let his voice drop to the low, sultry tone he usually reserved for a clandestine rendezvous. “Far be it from me to disappoint a lady, in anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He strode toward her, reached out, took her hand and lifted it to his lips. He pressed a gentle kiss upon her knuckles, then raised his eyes to regard her. “You, my lady, are the most surprising young woman I have ever met.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Her cheeks flushing, she tugged her hand away. “Hardly a compliment, sir knight. I’m not impressed.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He lifted the corners of his mouth in the sort of lazy smile he gave a woman after they had made love. “I assure you, a man likes to be surprised by a woman, and a truly surprising woman is a very rare creature.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("For the briefest of moments, her eyes widened in shock, and he wanted to shout with triumph.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Then her eyes flashed with that scornful fire that was becoming familiar. “Creature?” she demanded. “Is that what women are to you—creatures?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He tensed and became the knight who had won many tournaments. “Women who would make a mockery of a stranger and a guest are creatures to me, yes.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("“Becca, I think we’re heard quite enough from you at the moment,” Lord Throckton declared. He strode ")]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_vm._v("past her and sat in his thronelike chair. “This man is our guest and should be treated accordingly.”")])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She turned away from Blaidd to address her father. “I’m treating him as I treat all the men who come to see Laelia.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The way Lady Laelia’s lips turned down seemed to confirm that.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Damn it, Becca, that’s the trouble! When will you learn to behave? Why can’t you be more like your sister?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Because I am not my sister?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“You know what I mean!” Throckton gestured at the seat to his right. “Sit down, Sir Blaidd, sit down. Don’t mind Rebecca. Where’s the damn priest? Let’s have grace.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Wondering if this sort of exchange occurred frequently, and deciding that it probably did, if they would speak that way in front of a stranger, Blaidd did as he was told, taking the place accorded to honored guests. That also put him between Lord Throckton and Lady Laelia. Lady Rebecca was to her father’s left and, miraculously, once the grace was said, she seemed content to be silent.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Or maybe it was the fact that the conversation, such as it was, consisted of her father’s descriptions of the vast array of suitors who had sought Lady Laelia’s hand. Whenever there was a lull in the recitation, Laelia stayed silent or answered Blaidd’s questions as briefly as possible, no matter how he exerted himself to be charming.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_vm._v("If somebody were to tell him this place was be")]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("witched and everything he did had the opposite effect than usual—repelling rather than attracting a woman—he could believe it. On the other hand, he had to stay at Throckton Castle for some time, so if courting the lady was an uphill climb, it would give him a good excuse to linger.")])]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He looked around the hall for Trev and found him engaged in conversation with a serving maid who looked a little younger than the squire. She had a jug of wine balanced on her hip and swayed while winding a lock of ruddy-brown hair around her finger.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Ah, the universal sign of feminine interest. Perhaps a reminder of their duties as guests wouldn’t be amiss. And perhaps it would have been better if he’d come here alone, Blaidd thought.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Then I sent that young buck packing,” Lord Throckton declared, interrupting his musings. The man’s voice was slurred from the copious amount of wine that seemed necessary to keep his throat lubricated for the long enumeration. “That was the last of them till you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("That meant his recitation must be at an end, thank God, Blaidd realized as he turned to his host with a smile pasted on his face.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Lord Throckton put his broad hands on the table and heaved himself to his feet. Blaidd started to rise, too, but Lord Throckton waved him back down. “Just off to the garderobe. That French wine goes right through my English guts.” He gave Blaidd a rather sodden wink. “But it tastes too good not to drink it.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("With that, he made his way out of the hall, leaving ")]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_vm._v("only an empty chair between Blaidd and Lady Rebecca.")])]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He couldn’t resist the temptation. “So, my lady,” he said to her, “do you often play castle guard?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She regarded him steadily, obviously not the least embarrassed by his question. “No, sir knight.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“But today you thought to amuse yourself at my expense?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Not only myself. The garrison enjoyed it, too. I’m sorry you didn’t see the humor in it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He didn’t believe she was sorry at all. “Nobody likes to be made a fool of.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“No, and handsome young knights with all the world at their feet most of all. But humility is good for the soul, is it not, sir?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Yes, it is. It’s a pity you don’t possess that quality yourself.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She reared back slightly. “How can you say that? Of course I’m humble. How could I not be, when I must compare myself to my sister every day?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“What else could it be but arrogance to think you have the right to make a knight play the fool?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“If I am arrogant, what are you—a man who smiles at every woman he meets as if she must be fairly salivating with desire for him?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Becca!” Lady Laelia gasped.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Blaidd had forgotten she was there. “It’s all right, my lady,” he assured her. “I take no offense.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_vm._v("Nevertheless, Lady Laelia’s expression hardened and her lips thinned. No soft and gentle maiden was ")]), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_vm._v("she now; she was at war. He had seen women at such battles often enough to recognize the signs.")])]), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“If you’re so disposed to talk, sister,” she said through clenched teeth, “why don’t you tell him about the time you fell out of the apple tree?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Lady Rebecca flushed as her eyes flashed with anger. Blaidd suddenly had the sensation that he was caught between two enemy lines, without even a dagger to fight with.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Would you like to hear that story, Sir Blaidd?” Lady Rebecca asked with a serenity distinctly at odds with the look in her eyes. “It’s really terribly amusing.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Blaidd was quite sure it was anything but. “I think I have listened to enough stories for tonight. May we have some music instead?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Lady Rebecca continued to regard him with her steadfast and bold gaze. “I’ve heard that Welshmen are excellent singers. Perhaps you would prove the point, sir knight?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“He’s a noble guest, not some troubadour,” Lady Laelia protested.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Blaidd gave them both a friendly smile to show he took no offense. “It’s true that most Welshman can sing, something we are justly proud of. If you wish to hear my humble attempt at a ballad, I’ll be happy to oblige you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Lord Throckton came staggering back and threw himself into his chair. He looked from one daughter to the other, and his eyes narrowed. “What’s been going on?”")])]), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Becca has—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Been my usual annoying self,” she interrupted. “Sir Blaidd has just offered to sing us a Welsh ballad.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Has he now?” Lord Throckton cried, ignoring the first part of her comments. “Wonderful! I’ve always wanted to hear a Welshman sing. But before that, what do you say to some dancing?” He shouted at the young serving woman Trev had been talking to. “Meg, fetch Rebecca’s harp! Bran, Tom, take down the tables!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("It became too noisy for conversation as Meg disappeared up the stairs leading to the household apartments. The two male servants the lord had addressed quickly marshaled some others to help them take down the tables. The high table they would leave for last.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Your daughter plays the harp?” Blaidd asked when the worst of the noise abated.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Aye, and well, too.” Lord Throckton leaned toward Laelia, forcing Blaidd back in his chair. “But not so well as my Laelia dances!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("That explained the urgency to have dancing. The man wanted his daughter’s talents on display.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_vm._v("Meg reappeared, bearing a small stringed instrument. The reverent way she gave it to Lady Rebecca suggested that she was particular in its handling, as if it were very valuable. Yet the harp was plain, and although the wood had been polished to a bright sheen, it did not look to be worth much in itself. It ")]), _c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_vm._v("must be the value its possessor placed on it that made the servant treat it with so much care.")])]), _c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("While Lady Rebecca tuned the instrument, Blaidd rose and held out his hand to Laelia. She limply placed hers in his and allowed him to lead her to the cleared space.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Then Lady Rebecca began to play.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("How she played! Her fingers flew along the strings, coaxing out marvelous sounds and quick rhythms perfect for a round dance. As she played, she bent over the instrument, swaying, lost in the music with the true joy of the naturally gifted.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("If she were in Wales, she would be far more valued than Lady Laelia for her talent. As for Lady Laelia’s dancing, it was excellent, but she moved with all the joy of a soldier on a long forced march.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The dance came to an end and, applauding enthusiastically, Blaidd left Lady Laelia and approached her sister. “That was wonderful, my lady. You play very well indeed. If you dance as well as you play, you would astonish even the court. I hope you will dance next with me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Instead of being pleased, Lady Rebecca looked as if she’d like to strike him dead on the spot. She slowly got to her feet, clutching her harp so tightly her knuckles whitened. “If you will excuse me, Sir Blaidd, I’m going to retire.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Then she limped out of the hall.")])])]), _c('a', {
    attrs: {
      "id": "page39"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page39"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ff8de18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inthekingsservice_ch02.vue
// module id = 78
// module chunks = 0